module.exports = __webpack_public_path__ + "static/MiniShowreel-606c476bcec4d26b0f46ca65b16d2b84.mp4";